import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { EddyPage } from '@/pages/EddyPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/eddy" element={<EddyPage />} />
        <Route path="*" element={<Navigate to="/eddy" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
